namespace RedBullMOBILE360.Sms {
    export interface WhiteListForm {
        WhitelistName: Serenity.StringEditor;
        CreationDate: Serenity.DateEditor;
        LastUpdateDate: Serenity.DateEditor;
        CreatedBy: Serenity.IntegerEditor;
    }

    export class WhiteListForm extends Serenity.PrefixedContext {
        static formKey = 'Sms.WhiteList';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhiteListForm.init)  {
                WhiteListForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(WhiteListForm, [
                    'WhitelistName', w0,
                    'CreationDate', w1,
                    'LastUpdateDate', w1,
                    'CreatedBy', w2
                ]);
            }
        }
    }
}
